import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ReportsIntl } from "./Reports";
import "./App.scss";

const App = (props) => {
  const { language, locale } = props;

  return (
    <Router>
      <Route
        exact
        path="/:orgId/:token/boxscore"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="boxscore"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/boxscore/:periodId"
        render={(props) => {
          const { periodId } = props.match.params;
          // standard full boxscore
          if (periodId === "full")
            return (
              <ReportsIntl
                {...{ ...props.match.params, language, locale }}
                reportType="boxscore"
              />
            );
          else
            return (
              <ReportsIntl
                {...{ ...props.match.params, language, locale }}
                reportType="boxscorePerPeriod"
              />
            );
        }}
      />
      <Route
        path="/:orgId/:token/advancedBoxscore"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="advancedBoxscore"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/scoresheet"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="scoresheet"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/playbyplay"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="playbyplay"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/playbyplayfull"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="playbyplayfull"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/quarterscore"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="quarterscore"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/hockeyMatch"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="hockeyMatch"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/hockeyCards"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="hockeyCards"
            />
          );
        }}
      />
      <Route
        path="/:orgId/:token/shootout"
        render={(props) => {
          return (
            <ReportsIntl
              {...{ ...props.match.params, language, locale }}
              reportType="shootout"
            />
          );
        }}
      />
    </Router>
  );
};

export default App;
